import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import { BsArrowLeft } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import Panel from '#globalComponents/Overlay/Panel';
import FullscreenLayout from '#layouts/FullscreenLayout';

const GateScreen = ({ icon, title, children, action }) => (
	<FullscreenLayout width="w-full max-w-md px-4">
		<Panel>
			<Panel.Header icon={icon}>{title}</Panel.Header>
			<Panel.Body className="space-y-4">{children}</Panel.Body>
			<Panel.Footer stacked>
				{action && (
					<Button fullWidth variant="accent" shape="pill" onClick={action.onClick} loading={action.loading}>
						{action.label}
					</Button>
				)}
				<Link
					to="/dashboard"
					className="inline-flex items-center justify-center gap-1.5 text-sm text-bgBase-800 transition-colors hover:text-text"
				>
					<BsArrowLeft className="h-3.5 w-3.5" />
					Zurück zum Dashboard
				</Link>
			</Panel.Footer>
		</Panel>
	</FullscreenLayout>
);

GateScreen.propTypes = {
	icon: PropTypes.elementType.isRequired,
	title: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	action: PropTypes.shape({
		label: PropTypes.string.isRequired,
		onClick: PropTypes.func.isRequired,
		loading: PropTypes.bool,
	}),
};

export default GateScreen;
